import * as fromCheckIfRegisteredReducer from './check-if-registered.reducer';
import * as fromForgotPasscodeReducer from './forgot-passcode.reducer';
import * as fromLoginConfirmReducer from './login-confirm.reducer';
import * as fromLoginReducer from './login.reducer';
import * as fromLogoutReducer from './logout.reducer';
import * as fromNewUserPasscodeReducer from './new-user-passcode.reducer';
import * as fromRegisterReducer from './register.reducer';
import * as fromResendReducer from './resend-otp.reducer';
import * as fromValidateMobileNumberReducer from './validate-mobile-number.reducer';
import * as fromForgotPasscodeLoginConfirmReducer from './forgot-passcode-login-confirm.reducer';
import * as fromForgotPasscodeResendOtp from './forgot-passcode-resend-otp.reducer';
import * as fromForgotPasscodeVerify from './forgot-password-verify.reducer';
import * as fromMarketingOptions from './marketing-options.reducer';
import * as fromSignUp from './signup.reducer';
import * as fromValidateGovIdPassport from './validate-gov-id-passport.reducer';
import * as fromSignupSetPasscodeReducer from './signup-set-passcode.reducer';
import * as fromTermsAndConditionsReducer from './get-terms-and-conditions.reducer';
import * as fromLegalEntitiesForUserReducer from './legal-entities-for-user.reducer';
import * as fromVerifyEmailReducer from './verify-email.reducer';
import * as fromValidateTokenReducer from './validate-token.reducer';

export {
  fromCheckIfRegisteredReducer,
  fromForgotPasscodeReducer,
  fromLoginConfirmReducer,
  fromLoginReducer,
  fromLogoutReducer,
  fromNewUserPasscodeReducer,
  fromRegisterReducer,
  fromResendReducer,
  fromValidateMobileNumberReducer,
  fromForgotPasscodeLoginConfirmReducer,
  fromForgotPasscodeResendOtp,
  fromForgotPasscodeVerify,
  fromMarketingOptions,
  fromSignUp,
  fromValidateGovIdPassport,
  fromSignupSetPasscodeReducer,
  fromTermsAndConditionsReducer,
  fromLegalEntitiesForUserReducer,
  fromVerifyEmailReducer,
  fromValidateTokenReducer
};
